import APSelect from './APMultiSelect';

export {
  APSelect,
};

export default APSelect;
